<footer>
    <div class="first">
        <div class="left">
            <p>Główny organizator</p>
            <div class="logos">
                <a href="https://ceo.org.pl/" target="_blank">
                    <img src="../../../../assets/logo_ceo.jpg" />
                </a>
                <a href="https://nocbibliotek.ceo.org.pl/" target="_blank">
                    <img src="../../../../assets/logo_noc.jpg" />
                </a>
            </div>
        </div>
        <div class="center">
            <div class="logos">
                <div class="logos-links">
                    <img src="../../../../assets/dofinansowanie.jpg" />
                    <a href="https://nck.pl/projekty-kulturalne/projekty/ojczysty-dodaj-do-ulubionych" target="_blank" class="nck"></a>
                    <a href="https://mkidn.gov.pl/" target="_blank" class="mkidn"></a>
                </div>
            </div>
        </div>
        <div class="right">
            <p>Partnerzy</p>
            <div class="logos">
                <a href="http://www.calapolskaczytadzieciom.pl/" target="_blank">
                    <img src="../../../../assets/logo_calapolska.jpg" />
                </a>
            </div>
        </div>
    </div>
    <div class="second">
        <div class="logos">
            <a href="https://egmont.pl/" target="_blank">
                <img src="../../../../assets/logo_harper.jpg" />
            </a>
            <a href="http://wydawnictwoagora.pl/" target="_blank">
                <img src="../../../../assets/logo_agora.jpg" />
            </a>
            <a href="https://www.biuroliterackie.pl/" target="_blank">
                <img src="../../../../assets/logo_literackie.jpg" />
            </a>
            <a href="https://www.wydawnictwodwiesiostry.pl/" target="_blank">
                <img src="../../../../assets/logo_siostry.jpg" />
            </a>
            <a href="https://www.adamada.pl/" target="_blank">
                <img src="../../../../assets/logo_amanda.jpg" />
            </a>
            <a href="https://mamania.pl/" target="_blank">
                <img src="../../../../assets/logo_mamania.jpg" />
            </a>
            <a href="https://www.znak.com.pl/wydawnictwo-znak-emotikon" target="_blank">
                <img src="../../../../assets/logo_znak.jpg" />
            </a>
        </div>
    </div>
</footer>
